import React from 'react';
import styled, { css } from 'styled-components';

const TablePanelStyled = styled.table.attrs({
  className: 'panel__table',
})`
  ${props => {
    const { theme = {}, darkMode = false } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      border-collapse: collapse;

      th,
      td {
        border: 1px solid #000;
      }

      th {
        padding: 4px;
      }

      td {
        text-align: center;
      }
    `;
  }}
`;

const TablePanel = ({ heading, items }) => {
  return (
    <TablePanelStyled>
      <tr>
        {Object.keys(items).map((key, i) => <th key={`table-header-${i}`}>{key}</th>)}
      </tr>
      <tr>
        {Object.values(items).map((value, i) => <td key={`table-data-${i}`}>{value}</td>)}
      </tr>
    </TablePanelStyled>
  );
}

export default TablePanel;